import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const Notification = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path
      fill="#000"
      d="M4.01 19.675v-1.07h1.782v-9.02c0-1.505.48-2.833 1.442-3.982a6.193 6.193 0 0 1 3.642-2.162v-.598c0-.316.107-.581.32-.796.212-.215.478-.322.797-.322.32 0 .587.107.804.322.217.215.325.48.325.796v.598a6.209 6.209 0 0 1 3.65 2.162c.964 1.149 1.445 2.477 1.445 3.983v9.02H20v1.07H4.01Zm7.985 2.956a1.76 1.76 0 0 1-1.295-.539 1.773 1.773 0 0 1-.537-1.297h3.672c0 .509-.18.942-.54 1.3-.36.357-.794.536-1.3.536Zm-5.133-4.025h10.286v-9.02c0-1.424-.503-2.636-1.509-3.637-1.006-1-2.22-1.5-3.644-1.5-1.423 0-2.635.5-3.634 1.5-1 1-1.5 2.213-1.5 3.637v9.02Z"
    />
  </Svg>
);
export default Notification;
